/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useMemo} from "react";
import {Button, Dropdown, Badge} from "react-bootstrap";
import {IconButton} from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';
import {useSelector} from "react-redux";
import {useHistory, Link} from "react-router-dom";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {UserProfileDropdown} from "./dropdowns/UserProfileDropdown";
import {URLs} from "../../../../utils/routes";

export function QuickUserToggler() {
  const {user} = useSelector(state => state.auth);
  const history = useHistory();
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas: objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);
  const logoutClick = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }
    history.push("/logout");
  };

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <Dropdown>
            <Dropdown.Toggle
              as="span"
              variant="success"
              drop="bottom"
              id="dropdown-basic"
              className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 no-anchor"
            >
              <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
              <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                {user.adminId}
              </span>
              <span className="symbol symbol-35 symbol-light-success">
                <span className="symbol-label font-size-h5 font-weight-bold">
                  {user.adminId[0]}
                </span>
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="mt-1" style={{width: 240}}>
              <Dropdown.Header className="d-flex justify-content-between align-items-center">
                <h4 className="font-size-h4 font-weight-bold m-0">계정정보</h4>
                <Link to={URLs.ACCOUNT}>
                  <IconButton aria-label="Delete">
                    <SettingsIcon color="primary" />
                  </IconButton>
                </Link>
              </Dropdown.Header>
              <Dropdown.Divider />
              <Dropdown.Item as="span" disabled>
                {user.adminId}
                <Badge pill variant="light" className="ml-5">판매파트너</Badge>
              </Dropdown.Item>
              {/*<Dropdown.Item as="span" disabled>*/}
              {/*  {user.bsnOprName}{" "}*/}
              {/*  {user.bsnLicNum ? `(${user.bsnLicNum})` : ''}*/}
              {/*</Dropdown.Item>*/}
              <Dropdown.Divider />
              <div as="span" className="d-flex justify-content-end px-5 py-2">
                <Button size="sm" variant="dark" className="w-100px" onClick={logoutClick}>로그아웃</Button>
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}

      {!layoutProps.offcanvas && (<UserProfileDropdown/>)}
    </>
  );
}
